import { chakra, Text, Flex } from "@chakra-ui/react"
import { hexToRgba } from "lib/color"
import { colours } from "@shared/ui.design-system"

export const Offer = chakra(Flex, {
  baseStyle: {
    flexDirection: "column",
    backgroundColor: colours.secondary.light,
    borderRadius: "5px",
    p: 2,
    w: {
      base: "100%",
      md: "335px",
    },
    my: {
      base: 0,
      md: 1.5,
    },
    mx: "auto",
    textAlign: "left",
  },
})

export const VariationOffer = chakra(Flex, {
  baseStyle: {
    backgroundColor: colours.secondary.light,
    borderRadius: "5px",
    p: 2,
    w: {
      base: "100%",
      md: "460px",
    },
    my: {
      base: 0,
      md: 1.5,
    },
    mx: "auto",
    textAlign: "left",
    flexDirection: "column",
    position: "relative",
  },
})

export const PriceTerms = chakra(Flex, {
  baseStyle: {
    flexDirection: { base: "column", md: "row" },
    mt: "1",
    mb: "1",
    alignItems: { base: "unset", md: "center" },
    h4: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      letterSpacing: "2px",
      "&:after": {
        borderRight: `0.25px solid ${hexToRgba(colours.primary.dark, 0.25)}`,
        content: "' '",
        marginRight: -1,
        paddingLeft: -1,
        display: { base: "none", md: "inline-block" },
        height: "12px",
      },
    },
  },
})

export const OfferType = chakra(Text, {
  baseStyle: {
    mt: "0",
    lineHeight: "18px",
    pt: "6px",
    pb: "9px",
    gridColumn: "2",
    gridRow: "1",
  },
})

export const OfferTerms = chakra(Text, {
  baseStyle: {
    lineHeight: "22px",
    gridColumn: "1 / 4",
  },
})

export const CopyText = chakra(Text, {
  baseStyle: {
    letterSpacing: "0.01em",
    flexGrow: 1,
    li: {
      mb: -1,
    },
  },
})
